import type { Ref } from 'react';
import { Button } from '@ksyos/design-system';
import { translateKey } from '../../../translate';

interface ISaveSendButtonProps {
    buttonDisabled?: boolean;
    label?: string;
    saveSend: () => Promise<void>;
    saveSendButtonRef?: Ref<HTMLButtonElement>;
    tabIndex?: number;
}

export function SaveSendButton(props: ISaveSendButtonProps) {
    const buttonLabel = props.label ? props.label : translateKey('request.saveSend');

    return (
        <Button
            buttonRef={props.saveSendButtonRef}
            className="automation-saveSend"
            data-automation-test="saveSend"
            isDisabled={props.buttonDisabled}
            onClick={props.saveSend}
            tabIndex={props.tabIndex}
            type="button"
            variant="solid"
        >
            {buttonLabel}
        </Button>
    );
}
